import { AppThunkAction } from '../../reducers';
import { Sede } from '../../../models/Entities/Turnero';
import { ErrorType } from '../../../models/HttpError';

// services
import * as Services from '../../../services/Turnero-Sedes.Services';

// actions
import * as ActionEvents from '../../actions/Turnero-Sedes.Actions';
import {
    TurneroSedesCreateFailureAction,
    TurneroSedesCreateRequestAction,
    TurneroSedesCreateSuccessAction,
    TurneroSedesDeleteFailureAction,
    TurneroSedesDeleteRequestAction,
    TurneroSedesDeleteSuccessAction,
    TurneroSedesGetAllFailureAction,
    TurneroSedesGetAllRequestAction,
    TurneroSedesGetAllSuccessAction,
    TurneroSedesUpdateFailureAction,
    TurneroSedesUpdateRequestAction,
    TurneroSedesUpdateSuccessAction
} from '../../actions/Turnero-Sedes.Actions';

type KnownAction =
    | TurneroSedesGetAllRequestAction
    | TurneroSedesGetAllSuccessAction
    | TurneroSedesGetAllFailureAction
    | TurneroSedesCreateRequestAction
    | TurneroSedesCreateSuccessAction
    | TurneroSedesCreateFailureAction
    | TurneroSedesUpdateRequestAction
    | TurneroSedesUpdateSuccessAction
    | TurneroSedesUpdateFailureAction
    | TurneroSedesDeleteRequestAction
    | TurneroSedesDeleteSuccessAction
    | TurneroSedesDeleteFailureAction;

export const actionCreators = {
    GetSedes: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.TURNERO_SEDES_GET_ALL_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.TURNERO_SEDES_GET_ALL_REQUEST
        });

        Services.GetSedes(token)
            .then((response) => {
                dispatch({
                    type: ActionEvents.TURNERO_SEDES_GET_ALL_SUCCESS,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.TURNERO_SEDES_GET_ALL_FAILURE,
                    error
                });
            });
    },
    CreateSede: (payload: Sede): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.TURNERO_SEDES_CREATE_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.TURNERO_SEDES_CREATE_REQUEST,
            payload
        });

        Services.CreateSede(token, payload)
            .then((response) => {
                dispatch({
                    type: ActionEvents.TURNERO_SEDES_CREATE_SUCCESS,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.TURNERO_SEDES_CREATE_FAILURE,
                    error
                });
            });
    },
    UpdateSede: (id: number, payload: Sede): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.TURNERO_SEDES_UPDATE_FAILURE,
                id,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.TURNERO_SEDES_UPDATE_REQUEST,
            id,
            payload
        });

        Services.UpdateSede(token, id, payload)
            .then((response) => {
                dispatch({
                    type: ActionEvents.TURNERO_SEDES_UPDATE_SUCCESS,
                    id,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.TURNERO_SEDES_UPDATE_FAILURE,
                    id,
                    error
                });
            });
    },
    DeleteSede: (id: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.TURNERO_SEDES_DELETE_FAILURE,
                id,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.TURNERO_SEDES_DELETE_REQUEST,
            id
        });

        Services.DeleteSede(token, id)
            .then(() => {
                dispatch({
                    type: ActionEvents.TURNERO_SEDES_DELETE_SUCCESS,
                    payload: id
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.TURNERO_SEDES_DELETE_FAILURE,
                    id,
                    error
                });
            });
    }
};
